<template>
  <div class="pageControl">
    <el-pagination
      :total="props.total"
      :page-size="20"
      @current-change="onChangePageIndex"
      background
      small
    />
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    total: { type: Number, default: 0 },
    pageIndex: Number,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {});

    //分页控件点击事件
    const onChangePageIndex = (index) => {
      emit("onLoad", index);
    };

    return { state, props, onChangePageIndex };
  },
};
</script>
<style scoped>
.pageControl {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.pageControl > .el-pagination {
  margin: 0 auto;
  text-align: center;
}
</style>
